import React from 'react'
import SvgWrapper from '../SvgWrapper'
import type { IllustrationProps } from './types'

const RelaxationWomanIllustration: React.FC<IllustrationProps> = ({ height = 160, width = 146 }) => (
  <SvgWrapper height={height} width={width} viewBox="0 0 146 159.789" fill="none">
    <g clipPath="url(#a)">
      <path
        d="M37.839 68.948c16.788 0 30.398-13.61 30.398-30.4 0-16.788-13.61-30.398-30.398-30.398-16.79 0-30.4 13.61-30.4 30.399s13.61 30.399 30.4 30.399Z"
        fill="#FF0080"
      />
      <path
        d="M83.254 11.852 24.703 44.104c-6.764 8.672 121.754 9.208 120.694.032L88.62 11.884c-1.616-.918-3.735-.93-5.366-.032Z"
        fill="#A5A9DA"
      />
      <path
        opacity=".2"
        d="M83.254 11.852 24.703 44.104c-6.764 8.672 121.754 9.208 120.694.032L88.62 11.884c-1.616-.918-3.735-.93-5.366-.032Z"
        fill="#020537"
      />
      <path d="M131 160H8c83.118-15.223 33.286-13.212 123 0Z" fill="#CACDDA" />
      <path
        d="M82.095 9.16h4.396L85.009.805c-.092-.516-.443-.7-.716-.7-.273 0-.624.184-.715.7L82.095 9.16ZM86.525 36.726h-4.846V154.93h4.846V36.726Z"
        fill="#020537"
      />
      <path
        d="M84.116 55.179c-2.068 0-4.012-.8-5.481-2.26L66.404 40.776l.999-1.007 12.231 12.144a6.293 6.293 0 0 0 4.544 1.847 6.319 6.319 0 0 0 4.508-1.932l11.687-12.05 1.019.988-11.688 12.05a7.728 7.728 0 0 1-5.513 2.363h-.075Z"
        fill="#020537"
      />
      <path
        d="M85.81 45.908c-6.018 0-12.084-.02-17.972-.062-12.474-.089-23.124-.264-30.798-.507-13.081-.414-13.22-.885-13.28-1.086-.014-.046-.019-.136.104-.217l58.39-38.399a4.123 4.123 0 0 1 4.603.033l59.033 38.397c.123.084.117.174.103.22-.074.237-.298.955-26.217 1.377-9.862.16-21.814.244-33.966.244Z"
        fill="#A5A9DA"
      />
      <path
        d="M42.724 126.047c-2.095.322-3.628 1.663-3.423 2.996.204 1.333 2.068 2.153 4.164 1.832a5.304 5.304 0 0 0 2.33-.922l15.155-2.283.57-5.236-16.297 3.795a5.32 5.32 0 0 0-2.5-.182Z"
        fill="#D7B7A8"
      />
      <path d="m80.901 115.131-3.435 7.29-17.27 5.814.842-5.925 15.937-7.531 3.926.352Z" fill="#A5A9DA" />
      <path
        d="m49.05 142.81-3.085 7.801-3.99-2.721 2.358-8.164 4.717 3.084ZM36.169 139.907l-8.164 7.802 3.265 3.447 8.346-6.532-3.447-4.717ZM82.431 114.508l-.09-.635-2.087-4.082-6.894 1.814 1.27 5.625 7.802-2.722Z"
        fill="#D7B7A8"
      />
      <path
        d="m79.529 141.722.212 2.725s.876 11.426-6.2 12.333c-7.075.907-10.159 1.814-14.332-5.261l-6.53-11.612-3.816 4.54-5.075-3.995s3.629-14.151 6.532-14.696a6.577 6.577 0 0 1 1.082-.109c2.404-.05 4.669 1.125 6.107 3.052l8.231 11.027 2.994-1.361 10.795 3.357Z"
        fill="#2E35A8"
      />
      <path
        d="m40.341 150.249 1.834-2.705 4.207 1.997s1.398 4.88-.235 5.425c-1.633.544-6.169-.182-6.169-.182s-8.345 1.814-8.526.182c-.182-1.633 3.81-1.996 3.81-1.996l5.08-2.721Z"
        fill="#D7B7A8"
      />
      <path
        d="m58.12 148.072-12.608-7.945-6.44 5.767-4.355-5.079s7.983-11.793 10.341-12.337c2.359-.544 6.169-.907 6.169-.907l11.61 10.704-4.716 9.797Z"
        fill="#2E35A8"
      />
      <path
        d="m28.884 147.012 2.666 3.804-.105 1.173s-1.082 4.715-3.622 3.12c-2.54-1.595-2.721-1.958-2.721-1.958s-7.257 1.633-7.983-1.27c-.726-2.902 1.27-2.358 1.27-2.358l1.812 1.088 7.064-2.361 1.619-1.238ZM75.537 113.601a5.805 5.805 0 1 0 0-11.61 5.805 5.805 0 0 0 0 11.61Z"
        fill="#D7B7A8"
      />
      <path
        d="m74.177 116.05 8.345-2.54s3.266 7.62 2.721 11.067c-.544 3.447-5.502 19.87-5.502 19.87l-11.007-6.082s-.181-3.628-.726-5.261c-.544-1.633-2.268-6.622 1.542-10.795 3.81-4.172 4.627-6.259 4.627-6.259Z"
        fill="#A5A9DA"
      />
      <path
        d="M55.809 154.146c-1.358 1.627-1.62 3.647-.584 4.511 1.036.864 2.976.245 4.334-1.382a5.307 5.307 0 0 0 1.137-2.233l12.856-14.416-3.984-2.154-11.765 14.156a5.3 5.3 0 0 0-1.994 1.518Z"
        fill="#D7B7A8"
      />
      <path
        d="m80.578 119.711 1.973 7.813-9.277 14.849-4.783-3.47 1.295-1.037 7.534-15.935 3.258-2.22Z"
        fill="#A5A9DA"
      />
      <path
        d="M70.185 106.798c1.49-.004 1.574.006 1.815 0 1.846-.049 2.33-.775 3.265-.726 1.67.088-.534 8.465-1.451 12.337-.9 3.798 2.14 7.201 2.358 7.438 3.085 3.355 8.505 3.969 9.434 2.54.753-1.156-1.914-2.915-1.27-5.443.63-2.471 3.541-2.207 4.355-4.535.852-2.438-2.012-3.667-3.81-9.616-1.033-3.416-.85-4.052-1.815-6.168-2.576-5.655-15.206-3.248-13.788 1.996.274 1.014-.455 2.18.907 2.177Z"
        fill="#020537"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" transform="translate(0 .106)" d="M0 0h146v159.789H0z" />
      </clipPath>
    </defs>
  </SvgWrapper>
)

export default RelaxationWomanIllustration
